import { useMemo } from "react";

import { ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import LocationType from "src/types/LocationType";

import { getStyles, isChildMenuItemSelected, getIconFromLocationType } from "../sidebar.helpers";

export function LocationRow({
  open,
  locationType,
  location,
  pathname,
  onSelect,
}: {
  open: boolean;
  locationType: LocationType;
  location: { id: string; label: string };
  pathname: string;
  onSelect: (id: string) => void;
}) {
  const theme = useTheme();
  const icon = useMemo(() => getIconFromLocationType(locationType), [locationType]);

  return (
    <ListItem>
      <ListItemButton
        selected={isChildMenuItemSelected(pathname, location.id, locationType)}
        sx={getStyles(theme).listItemButton(true)}
        onClick={() => onSelect(location.id)}
      >
        <ListItemIcon sx={getStyles(theme).listItemIcon(open)}>{icon}</ListItemIcon>
        <ListItemText
          primaryTypographyProps={getStyles(theme).listItemPrimaryTypographyProps}
          primary={location.label}
          sx={getStyles(theme).childListItemText(true)}
        />
      </ListItemButton>
    </ListItem>
  );
}
